import React from "react";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "routers/types/stack";

import { Input, Header, ScrollLayout, Button } from "components";
import { useForm, Controller } from "react-hook-form";

import { patterns, sizes, strings } from "assets/constants";
import { View } from "react-native";
import { useCreateCorp } from "clients/apis";
import { _goToBack } from "routers/helper";

type CorpFormT = { name: string; ceo: string; mobile: string };

const AddCorp = () => {
  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<CorpFormT>({
    defaultValues: {
      name: "",
      ceo: "",
      mobile: "",
    },
  });

  const createCorpMut = useCreateCorp();

  const _onSubmit = () =>
    _onCreate({
      name: getValues().name,
      cto: { name: getValues().ceo, mobile: getValues().mobile },
    });

  const _onCreate = (data: CreateCorpReqT) =>
    createCorpMut.mutate(data, { onSuccess: _goToBack });

  return (
    <>
      <Header title={strings.corp} />

      <ScrollLayout
        style={{ alignSelf: "center", maxWidth: 600, width: "100%" }}
        contentContainerStyle={{ maxWidth: 600 }}
      >
        <View
          style={{
            width: "100%",
            maxWidth: 600,
            marginTop: 30,
            alignSelf: "center",
          }}
        >
          <Controller
            control={control}
            name="name"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  placeholder={strings.insert_company_name}
                  value={value}
                  onChangeText={onChange}
                  error={errors?.name?.message}
                  icon={{ type: "fontAwesome", name: "building-o" }}
                />
              );
            }}
          />

          <Controller
            control={control}
            name="ceo"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  placeholder={strings.insert_ceo_name}
                  value={value}
                  onChangeText={onChange}
                  error={errors?.ceo?.message}
                  icon={{ type: "fontAwesome", name: "user-o" }}
                />
              );
            }}
          />

          <Controller
            control={control}
            rules={{
              required: { value: true, message: strings.fill_input },
              pattern: {
                value: patterns?.mobile,
                message: strings.invalid_mobile,
              },
            }}
            name="mobile"
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  placeholder={strings.insert_ceo_mobile}
                  value={value}
                  onChangeText={onChange}
                  keyboardType="phone-pad"
                  maxLength={11}
                  icon={{ type: "fontAwesome", name: "mobile", size: 30 }}
                  error={errors?.mobile?.message}
                />
              );
            }}
          />

          <Button
            style={{ marginTop: 2 * sizes.space }}
            onPress={handleSubmit(_onSubmit)}
            title={{ value: strings.confirm }}
            loading={createCorpMut?.isLoading}
          />
        </View>
      </ScrollLayout>
    </>
  );
};

export default AddCorp;
